// extracted by mini-css-extract-plugin
export default {"settingsPage":"Settings_settingsPage__I3fwm"};